import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSource = () => {
  try {
    let s = sessionStorage.getItem("airpog_src");
    if (s) return s;
    const p = new URLSearchParams(window.location.search);
    s = (p.get("utm_source") || p.get("src") || p.get("ref") || "").toLowerCase().slice(0, 40);
    if (!s && document.referrer) {
      const host = new URL(document.referrer).hostname.replace(/^www\./, "");
      if (host && host !== window.location.hostname.replace(/^www\./, "")) s = host.slice(0, 40);
    }
    s = s || "direct";
    sessionStorage.setItem("airpog_src", s);
    return s;
  } catch {
    return "direct";
  }
};

export const Turnstile = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      const payload = JSON.stringify({ path: pathname, source: getSource() });
      const blob = new Blob([payload], { type: "application/json" });
      if (!navigator.sendBeacon || !navigator.sendBeacon(`${API}/turnstile/hit`, blob)) {
        fetch(`${API}/turnstile/hit`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
      }
    } catch { /* never block the app for analytics */ }
  }, [pathname]);
  return null;
};
